import React from 'react';

interface ImageProps {
  image: string;
}

export const Image = ({ image }: ImageProps) => (
  <div className="image" dangerouslySetInnerHTML={{ __html: image }}></div>
);
